import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.el.$on('click.loadmore', (e) => { e.preventDefault(); this.loadMore(); });
        this.fetching = false;
    }

    loadMore() {
        console.log('Load more');
        if (this.fetching) return;
        this.fetching = true;
        fetch(this.el.href).then(response => response.text()).then(html => {

            const parser = document.createElement('div');
            parser.innerHTML = html;
            const news = parser.querySelectorAll('.js-post-list > div');
            console.log(news);
            news.forEach((el) => {
                document.querySelector('.js-post-list').appendChild(el);
            })

            if (parser.querySelector('[data-module="LoadMore"]')) {
                this.el.href = parser.querySelector('[data-module="LoadMore"]').href;
            }
            else {
                this.el.remove();
            }
            document.querySelectorAll('.js-post-list [data-scroll]').forEach((el) => {
                el.classList.add('is-inview');
            })
            this.fetching = false;
        });
    }

    destroy() {
        this.el.$off('click.loadmore');
    }
}
